import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ $isHovering?: boolean }>`
    width: 100%;
    height: 100%;
    position: absolute;
    inset: 0;

    border-radius: 6px;
    overflow: hidden;
    pointer-events: none;

    transition: background-color 0.2s ease-in-out;

    ${({ $isHovering }) =>
        $isHovering &&
        css`
            background-color: rgba(0, 0, 0, 0.5);
            box-shadow: inset 0 0 100px rgba(0, 0, 0, 0.25);
        `}
`;
